import SplitType from 'split-type'
// import { gsap } from 'gsap'
// import SplitText from 'gsap/SplitText'

// gsap.registerPlugin(SplitText)

function textAnimations(parent = document) {
  // Automatic text split
  if (parent.querySelectorAll('[data-split]')) {
    setTimeout(() => {
      parent.querySelectorAll('[data-split]').forEach((splitElt) => {
        const splitType = splitElt.getAttribute('data-split')
          ? splitElt.getAttribute('data-split')
          : 'lines,words'
        const selector
          = splitElt.querySelectorAll('p').length > 0
            ? splitElt.querySelectorAll('p')
            : splitElt
        const split = new SplitType(selector, { types: splitType })

        if (splitElt.hasAttribute('data-split-animation')) {
          if (split.lines) {
            split.lines.forEach((l, index) => {
              l.style.setProperty('--l-index', index)
            })
          }
          if (split.words) {
            split.words.forEach((w, index) => {
              w.style.setProperty('--w-index', index)
            })
          }
          if (split.chars) {
            split.chars.forEach((c, index) => {
              c.style.setProperty('--c-index', index)
            })
          }
        }
      })
    }, 0)
  }
}

export { textAnimations }
